import { render, staticRenderFns } from "./MuhasebeKategorileri.vue?vue&type=template&id=becb383c"
import script from "./MuhasebeKategorileri.vue?vue&type=script&lang=js"
export * from "./MuhasebeKategorileri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports